import { APPEARANCES } from "./constants";
// eslint-disable-next-line import/prefer-default-export
export var getAppearance = function getAppearance(appearance) {
  return APPEARANCES[appearance] || APPEARANCES.standard;
};